import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { Ng2Cable } from 'ng2-cable';
import { SharedService } from '../shared/shared.service';
import { API } from '.././core/app-config';
import { Observable, from } from 'rxjs';
import { UserListEntity } from './textchat.model';
import { map } from 'rxjs/operators';

@Injectable()
export class TextChatService {
    // apiUrl = 'https://chat.fieldpower.com/'; 'http://172.16.9.31:5000/'
    apiUrl: string;
    headers: any;
    actionCable: any;
    actionCableSubscribe: boolean = false;

    constructor(public http: HttpClient, private sharedService: SharedService) {

        this.headers = {
            'Authorization': 'Duc0123',
            'Content-Type': 'application/json',
            'OrgID': this.sharedService.globalInfo().CompanyId.toString(),
            'UserID': this.sharedService.globalInfo().Email
        };
        this.apiUrl = API.TXTCHAT;
    }

    // startSubscribe() {
    //     if (!this.actionCableSubscribe) {
    //         this.actionCableSubscribe = true;
    //         this.actionCable = this.ng2cable.actionCable.createConsumer(this.apiUrl + 'cable?email=' + this.sharedService.globalInfo().Email);
    //     }
    // }

    startUnSubscribe() {
        if (this.actionCableSubscribe) {
            this.actionCableSubscribe = false;
            if (this.actionCable.subscriptions.subscriptions.length > 0) {
                for (var i = 0; i <= this.actionCable.subscriptions.subscriptions.length; i++) {
                    this.actionCable.subscriptions.remove(this.actionCable.subscriptions.subscriptions[0]);
                }
            }
        }
    }

    // Get users
    getUsers() {
        return new Promise((resolve) => {
            this.http.get(this.apiUrl + 'DucontMessenger/users.json', { headers: this.headers }).subscribe(res => {
                resolve(res);
            }, (err) => {
                //this.serviceProvider.showWebApiAlert(); 
            });
        });
    }

    registerUser(data) {
        return new Promise((resolve) => {
            this.http.post(this.apiUrl + 'DucontMessenger/signup', data, { headers: this.headers }).subscribe(res => {
                resolve(res);
            }, err => {
                //this.serviceProvider.showWebApiAlert();
            });
        });
    }
    registerOrg(data) {
        return new Promise((resolve) => {
            this.http.post(this.apiUrl + 'DucontMessenger/createorg', data, { headers: this.headers }).subscribe(res => {
                resolve(res);
            }, err => {
                //this.serviceProvider.showWebApiAlert();
            });
        });
    }

    // Get Conversation from Home
    getConversationsHome(id) {
        return new Promise((resolve) => {
            this.http.get(this.apiUrl + 'conversations/' + id, { headers: this.headers }).subscribe(res => {
                resolve(res);
            }, (err) => {
                //this.serviceProvider.showWebApiAlert();
            });
        });
    }

    // Get Conversation from Users
    getHomeConversations() {
        return new Promise((resolve) => {
            this.http.get(this.apiUrl + 'conversations.json', { headers: this.headers }).subscribe(res => {
                resolve(res);
            }, (err) => {
                console.log("Err", err);
                //this.serviceProvider.showWebApiAlert();
            });
        });
    }

    // Get Chat
    getChatDetails(receiver_id) {
        return new Promise((resolve) => {
            this.http.get(this.apiUrl + 'personal_messages/new?receiver_id=' + receiver_id, { headers: this.headers }).subscribe(res => {
                resolve(res);
            }, (err) => {
                //this.serviceProvider.showWebApiAlert();
            });
        });
    }

    // Get User Status
    getUserStatus(userId) {
        return new Promise((resolve) => {
            this.http.get(this.apiUrl + 'DucontMessenger/onlinecheck?userido=' + userId, { headers: this.headers }).subscribe(res => {
                resolve(res);
            }, (err) => {
                resolve(err);
            });
        });
    }

    // Post - create new message
    createPost(data) {
        return new Promise((resolve) => {
            this.http.post(this.apiUrl + 'personal_messages', data, { headers: this.headers }).subscribe(res => {
                resolve(res);
            }, err => {
                //this.serviceProvider.showWebApiAlert();
            });
        });
    }

    clearAllMessage(convoId: Number) {
        return new Promise((resolve) => {
            this.http.patch(this.apiUrl + 'personal_messages/' + convoId, { "delfor": 2 }, { headers: this.headers }).subscribe(res => {
                resolve(res);
            }, err => {
                //this.serviceProvider.showWebApiAlert();
            });
        });
    }



}
